// extracted by mini-css-extract-plugin
export default {"root":"IconEyeClose_root__x4wL1"};